<div class="ccl-form-field-wrapper" 
     [class.ccl-form-field-wrapper--disabled]="isDisabledState"
     [class.ccl-form-field-wrapper--error]="isErrorState"
     [class.ccl-form-field-wrapper--success]="isSuccessState">
  
  @if (label) {
    <label [for]="fieldId" class="ccl-form-field-wrapper__label">
      {{ label }}
      @if (required) {
        <span class="ccl-form-field-wrapper__required" aria-label="required">*</span>
      }
    </label>
  }

  <div class="ccl-form-field-wrapper__input-container">
    <ng-content></ng-content>
  </div>

  @if (hint && !isErrorState) {
    <span [id]="hintId" class="ccl-form-field-wrapper__hint">
      {{ hint }}
    </span>
  }

  @if (error || isErrorState) {
    <span [id]="errorId" class="ccl-form-field-wrapper__error" role="alert">
      {{ error }}
    </span>
  }
</div>


